// extracted by mini-css-extract-plugin
export default {"background":"Modal_background__Ow3v5","window":"Modal_window__nZFLX"};